/**
 * Student List Reducers
 */
import {
    CONTRACT_STUDENT_ACTION,
    CONTRACT_ALL_STUDENT,
    CONTRACT_ADD_STUDENT,
    CONTRACT_FETCH_STUDENT,
    CONTRACT_EDIT_STUDENT,
    CONTRACT_DELETE_STUDENT,
    CONTRACT_UPDATE_ENROLMENT,
    CONTRACT_UPDATE_NOTES,
    CONTRACT_PROGRAM_INCLUSION,
    DELETE_PROGRAM_INCLUSION,
    CONTRACT_UPLOAD_DOCUMENT,
    CONTRACT_FETCH_DCOUMENT,
    DELETE_CONTRACT_DOCUMENT,
    ADD_PROGRAM_INCLUSION,
    ADD_AGREEMENT,
    FETCH_AGREEMENT,
    FETCH_AGREEMENT_PROGRAMINCLUSION,
    SEND_AGREEMENT,
    EDIT_AGREEMENT,
    ACCEPT_AGREEMENT,
    DELETE_STUDENT_AGREEMENT,
    CANCEL_STUDENT_AGREEMENT,
    FETCH_PROGRAM_DETAILS,
    ADD_PROGRAM_DETAILS,
    ALL_FINANCIAL_YEAR,
    ALL_AGREEMENT_TYPE,
    ALL_AGREEMENT_FOR,
    ALL_AGREEMENT_PROGRAM,
    ALL_GOLF_PROGRAM,
    PARENT_ALL_CONTRACT,
    PARENT_ALL_DOCUMENT,
} from 'Actions/types';


const INIT_STATE = {
    contractstudentlist: [],
    particularcontractstudent: [],
    particularcontractdocument:[],
    particularagreementdetails:[],
    agreementprograminclusion:[],
    allagreementfinancial:[],
    allagreementtype:[],
    allagreementfor:[],
    allagreementprogram:[],
    allparentagreement:[],
    allparentdocument:[],
    allgolfprogram:[],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case CONTRACT_STUDENT_ACTION:
            return { ...state, loading: true };

        case CONTRACT_ALL_STUDENT:
            return { ...state, loading: false, contractstudentlist: action.payload };

        case CONTRACT_ADD_STUDENT:
            return { ...state, loading: false };

        case CONTRACT_FETCH_STUDENT:
            return { ...state, loading: false, particularcontractstudent: action.payload };

        case CONTRACT_EDIT_STUDENT:
            return { ...state, loading: false };

        case CONTRACT_DELETE_STUDENT:
            return { ...state, loading: false };

        case CONTRACT_UPDATE_ENROLMENT:
            return { ...state, loading: false };

        case CONTRACT_UPDATE_NOTES:
            return { ...state, loading: false };

        case CONTRACT_PROGRAM_INCLUSION:
            return { ...state, loading: false };

        case DELETE_PROGRAM_INCLUSION:
            return { ...state, loading: false };

        case CONTRACT_UPLOAD_DOCUMENT:
            return { ...state, loading: false };
        
        case CONTRACT_FETCH_DCOUMENT:
            return { ...state, loading: false, particularcontractdocument: action.payload };

        case DELETE_CONTRACT_DOCUMENT:
            return { ...state, loading: false };
        

        case ADD_PROGRAM_INCLUSION:
            return { ...state, loading: false };

        case ADD_AGREEMENT:
            return { ...state, loading: false };

        case FETCH_AGREEMENT:
            return { ...state, loading: false, particularagreementdetails: action.payload };

        case FETCH_AGREEMENT_PROGRAMINCLUSION:
            return { ...state, loading: false, agreementprograminclusion: action.payload };

        case ALL_FINANCIAL_YEAR:
            return { ...state, loading: false, allagreementfinancial: action.payload };

        case ALL_AGREEMENT_TYPE:
            return { ...state, loading: false, allagreementtype: action.payload };

        case ALL_AGREEMENT_FOR:
            return { ...state, loading: false, allagreementfor: action.payload };

        case ALL_AGREEMENT_PROGRAM:
            return { ...state, loading: false, allagreementprogram: action.payload };

        case ALL_GOLF_PROGRAM:
            return { ...state, loading: false, allgolfprogram: action.payload };

        case SEND_AGREEMENT:
            return { ...state, loading: false };

        case ACCEPT_AGREEMENT:
            return { ...state, loading: false };

        case EDIT_AGREEMENT:
            return { ...state, loading: false };

        case DELETE_STUDENT_AGREEMENT:
            return { ...state, loading: false };

        case CANCEL_STUDENT_AGREEMENT:
            return { ...state, loading: false };

        case FETCH_PROGRAM_DETAILS:
            return { ...state, loading: false };

        case ADD_PROGRAM_DETAILS:
            return { ...state, loading: false };

        case PARENT_ALL_CONTRACT:
            return { ...state, loading: false, allparentagreement: action.payload };

        case PARENT_ALL_DOCUMENT:
            return { ...state, loading: false, allparentdocument: action.payload };

        default: return { ...state };

    }
}